import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { removeMilestoneError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (milestone) => {
    return present(
      repository
        .removeMilestone(milestone)
        .then(() => milestone)
        .catch((e) =>
          Promise.reject({
            error: { ...removeMilestoneError, ...e },
            milestone,
          }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
